import { lazy, memo, Suspense } from 'react'
import AsyncLocalStorage from '@createnextapp/async-local-storage'

let MyComponent = lazy(async () => {
  let data
  try {
    data = await AsyncLocalStorage.getItem('dataImport')
    let dataParse = JSON.parse(data)
    return import(`src/components/customComponents/${dataParse?.folder}/${dataParse?.file}`)
  } catch (e) {
  }
})

export const ImportDynamically = memo((props) => {
  return (
    <Suspense>
      <MyComponent {...props} />
    </Suspense>
  )
})
